module.exports = __webpack_public_path__ + "img/Feature.f2f2826d.png";